module.exports = __webpack_public_path__ + "static/thumb5-894fa2f2e5b8ce6c5b73e625bc478832.jpg";